import { Button, Drawer } from "@components";
import styles from "styles/pages/reports/reports.module.scss";
import { IdentificationRegistrationDataChart } from "./IdentificationRegistrationDataChart";
import { useState } from "react";
import { Numbers } from "shared/utils/Numbers";

export default function IdentificationRegistrationData({
  data,
  onFetchHistory,
  loading,
}) {
  const registrationData = [
    {
      label: "telefone",
      value: data?.has_phone?.value || 0,
      percentage: data?.has_phone?.percentage || 0,
    },
    {
      label: "CPF",
      value: data?.has_document?.value || 0,
      percentage: data?.has_document?.percentage || 0,
    },
    {
      label: "e-mail",
      value: data?.has_email?.value || 0,
      percentage: data?.has_email?.percentage || 0,
    },
  ];

  const [selectedData, setSelectedData] = useState(null);

  return (
    <div className={styles.box} style={{ flex: 1, minWidth: "40%" }}>
      <div className="d-flex align-center justify-between mb-20">
        <div className="d-flex align-center gap-5">
          <p className={styles.label}>Identificação por dado cadastral</p>
          <span
            className={styles.info}
            title="Situação da sua base perante cada dado identificador."
          >
            <i className="fal fa-info-circle" />
          </span>
        </div>
        <Button
          design="default-icon-mini-3"
          onClick={() =>
            setSelectedData({
              name: "Identificação por dado cadastral",
            })
          }
        >
          <i className="fas fa-chart-waterfall" />
        </Button>
      </div>

      <div className={styles.columns}>
        {registrationData.map((item) => {
          return (
            <div key={item.label} className={styles.column}>
              <div
                className={styles.percent}
                style={{ height: `${item.percentage}%` }}
              >
                <p>
                  {Numbers.number(item.percentage)}% tem {item.label}
                </p>
                <span>{Numbers.formatInt(item.value)} clientes</span>
              </div>
            </div>
          );
        })}
      </div>

      <Drawer
        visible={selectedData}
        onClose={() => setSelectedData(null)}
        withoutTransition
        direction="full-center"
        showCloseButton={false}
      >
        <IdentificationRegistrationDataChart
          selectedData={selectedData}
          onFetchData={onFetchHistory}
          loading={loading}
          onClose={() => setSelectedData(false)}
          startOn2025
          startOnMonth={6}
          startOnYear={2025}
        />
      </Drawer>
    </div>
  );
}
